export default __webpack_public_path__ + "static/Emailsignature-07ccb406e168caa064786cd09297afae.svg";